import React from 'react';

export function DollarAppend() {
  return (
    <div className="input-group-append">
      <div className="input-group-text">$</div>
    </div>
  );
}
